<template>
    <div class="upgrade-to-pro-modal">
      <i class="close-modal" @click="close"></i>
      <div class="pro-icon">
        <img src="/main/img/icons/popups/eye-off-green.svg?ver=2" />
      </div>
      <div class="text">
        <p>
          {{ trans('modal_pro_visit_upgrade_description') }}
        </p>
      </div>
      <button @click="goToUpgradePage"  class="edit-button btn">{{ trans('upgrade_now')}}!</button>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    props: [],
    mixins: [
      require('@general/lib/mixin').default
    ],
    computed: {
        ...mapGetters({
        }),
      activeModal: {
        get: function() {
          return true;
        },
        set: function(value) {
          this.$emit('hideModal', value)
        }
      }
    },
    methods: {
        ...mapActions([
          'closeProfileSettings'
        ]),
      goToUpgradePage(){
        if (app.isDesktop) {
          this.closeProfileSettings();
          this.$store.dispatch('updateSidebarVisibility', {index: 'profile', value: false})
        }
        app.$router.push('/profile/pro');
        this.close();
      },
      close(){
        this.activeModal = false;
      }
    },
  data() {
    return {
    }
  }
}
</script>
